import { useState, useEffect, useRef } from "react";
import axios from "axios";

import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./carousel.css";
import EditLink from "../shared/edit-link";

const Carousel1 = () => {
  const [posts, setPosts] = useState([]);
  const STATIC_URL = process.env.REACT_APP_STATIC_URL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const URL = process.env.REACT_APP_API_URL;
        const res = await axios.get(`${URL}/posts?section=intro`);
        setPosts(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, [posts]); //

  return (
    <Carousel
      id="carouselId"
      useKeyboardArrows={true}
      transitionTime={1200}
      // animationHandler={rotateAnimationHandler}
      swipeable={false}
      autoPlay={true}
      infiniteLoop
      showThumbs={false}
      renderIndicator={(onClickHandler, isSelected, index, label) => {
        const defStyle = {
          marginLeft: 20,
          marginBottom: 5,
          height: 20,
          width: 20,
          backgroundColor: "white",
          borderRadius: 90,
          borderColor: "white",
          cursor: "pointer",
        };
        const style = isSelected
          ? { ...defStyle, backgroundColor: "silver" }
          : { ...defStyle };
        return (
          <button
            style={style}
            onClick={onClickHandler}
            onKeyDown={onClickHandler}
            value={index}
            key={index}
            role="button"
            tabIndex={0}
            aria-label={`${label} ${index + 1}`}
          ></button>
        );
      }}
    >
      {posts.map((post, index) => (
        <div className="slideContainer" key={index}>
          <div
            style={{
              backgroundColor: "white",
              height: "15px",
              width: "30px",
            }}
          >
            <EditLink id={post.id} />
          </div>

          <img
            className="slideImg"
            alt={post.title}
            src={`${STATIC_URL}/${post.img}`}
            key={index}
          />

          <p className="legend" style={{ fontSize: 24 }}>
            {post.title}
          </p>
        </div>
      ))}
    </Carousel>
  );
};
export default Carousel1;
